/* eslint-disable react-hooks/rules-of-hooks */
import { createStandaloneToast } from '@chakra-ui/react';
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import configs from 'configs';
import { ENDPOINT } from 'services/configs/endpoint.constant';

import { ERROR_CODE } from './errorcode';
import { getStorage, STORAGE_KEY } from './storage';

export const urlSSE = `${configs.base.BACKEND_URL}${ENDPOINT.SSE_CONNECTION}`;
const { toast } = createStandaloneToast();
const client = axios.create({
  baseURL: configs.base.BACKEND_URL,
  timeout: 1800000,
});

const requestChangePassword = async ({
  method,
  url,
  data,
  params,
  headers,
  responseType,
  ...rest
}: AxiosRequestConfig) => {
  const onSuccess = (response: AxiosResponse) => {
    toast({
      title: 'Change password successfully!',
      status: 'success',
      isClosable: true,
      position: 'bottom-right',
    });
    return response?.data;
  };
  const onError = (error: AxiosError<{ error_message: string }>) => {
    switch (error.response?.status) {
      case ERROR_CODE.INTERNAL_SERVER_ERROR: {
        toast({
          title: 'Error',
          description: error.response.data?.error_message
            ? error.response.data?.error_message
            : 'Something went wrong. Try again',
          status: 'error',
          isClosable: true,
          position: 'bottom-right',
          duration: 5000,
        });
        return {
          message: error.response.data?.error_message
            ? error.response.data?.error_message
            : 'Something went wrong. Try again',
          success: false,
        };
      }
      case ERROR_CODE.FORBIDDEN: {
        toast({
          title: 'Error',
          description: error.response.data?.error_message
            ? error.response.data?.error_message
            : 'Something went wrong. Try again',
          status: 'error',
          isClosable: true,
          position: 'bottom-right',
        });

        return {
          message: error.response.data?.error_message
            ? error.response.data?.error_message
            : 'Something went wrong. Try again',
          success: false,
        };
      }
      case ERROR_CODE.ERR_CLIENT: {
        toast({
          title: 'Error',
          description: error.response.data?.error_message
            ? error.response.data?.error_message
            : 'Something went wrong. Try again',
          status: 'error',
          isClosable: true,
          position: 'bottom-right',
        });
        return {
          message: error.response.data?.error_message
            ? error.response.data?.error_message
            : 'Something went wrong. Try again',
          success: false,
        };
      }
      case ERROR_CODE.UNAUTHENTICATED: {
        // document.cookie = "a_j=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
        // authInstance.logout();
        toast({
          title: 'Error',
          description: 'Wrong old password',
          status: 'error',
          isClosable: true,
          position: 'bottom-right',
        });
        return ERROR_CODE.UNAUTHENTICATED;
      }
      default: {
        return {
          message: 'unknown',
          success: false,
        };
      }
    }
  };

  const token = getStorage(STORAGE_KEY.TOKEN);

  return client({
    method,
    headers: {
      ...(token
        ? {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
          }
        : {}),
      ...headers,
    },
    url,
    params,
    data,
    ...(responseType ? { responseType } : {}),
    ...rest,
  })
    .then(onSuccess)
    .catch(onError);
};

export default requestChangePassword;
